import { getHttpApi } from '@cian/http-api/browser';
import {
  fetchGeocodedForSearch,
  TGeocodedForSearchRequest,
  TGeocodedForSearchResponse,
} from '../../repositories/geo/v1/geocoded-for-search';

export async function getGeocodedSearchData(parameters: TGeocodedForSearchRequest) {
  try {
    const httpApi = getHttpApi();
    const { response, statusCode }: TGeocodedForSearchResponse = await fetchGeocodedForSearch({
      httpApi,
      parameters,
    });

    if ('errors' in response || statusCode !== 200) {
      throw response;
    }

    return response;
  } catch (error) {
    throw error;
  }
}
